import { axios } from '@/utils/axios'
import { aclOrderStatusMap, productTypeMap, aclSubOrderStatusMap } from '@/dicts/ancillary'
import { idTypeV2Map } from '@/dicts/order'

// 新版辅营订单列表查询
export async function queryAncillaryListNew (params) {
  try {
    return await axios({
      url: '/api/mtsOrder/page',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版辅营订单详情查询
export async function queryAncillaryDetailNew (params) {
  try {
    const data = await axios({
      url: '/api/mtsOrder/detail',
      method: 'post',
      data: params
    })

    if (data) {
      const { timeLimit, status, passengers } = data

      data.orderDuration = new Date(timeLimit).getTime() - new Date().getTime()
      data.statusCn = aclOrderStatusMap[status]
      passengers.forEach((pass) => {
        pass.certificateTypeCn = idTypeV2Map[pass.certificateType]
        const item = pass.details?.find(item => { return (item.ticketNo && item.issCode) })
        if (item) {
          const { ticketNo, issCode } = item
          pass.ticketNo = issCode + '-' + ticketNo
        }

        pass.details.forEach((prod) => {
          if (prod.productType === 'LUGGAGE') {
            prod.productName = `预付费行李${prod.productName}`
          }
          prod.productTypeCn = productTypeMap[prod.productType]
          prod.orderStatusCn = aclOrderStatusMap[prod.orderStatus]
          prod.subOrderStatusCn = aclSubOrderStatusMap[prod.subOrderStatus]
        })
      })
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版随票辅营订单取消
export async function cancelExtProductNew (params) {
  try {
    return await axios({
      url: '/api/mtsOrder/cancel',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 通用随票辅营取消订单-v2
export async function cancelExtProductV2 (params) {
  try {
    return await axios({
      url: '/api/mtsOrder/V2/cancel',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版辅营子订单详情查询
export async function queryAncillarySubDetailNew (params) {
  try {
    const data = await axios({
      url: '/api/mtsOrder/sub/detail',
      method: 'post',
      data: params
    })

    if (data) {
      const { status, extProductType, paxSegmentInfoDTO } = data
      if (extProductType === 'LUGGAGE') {
        data.extraProductInfo.name = `预付费行李${data.extraProductInfo?.name}`
      }
      data.statusCn = aclSubOrderStatusMap[status]
      data.extProductTypeCn = productTypeMap[extProductType]
      paxSegmentInfoDTO.certificateTypeCn = idTypeV2Map[paxSegmentInfoDTO.certificateType]
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 预付费行李计算器
export async function queryBasePriceList (params) {
  try {
    return await axios.post('/api/mtsOrder/queryBasePriceList', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 旧版辅营订单

// 辅营子订单列表查询
export async function queryAncillaryListV1 (params) {
  try {
    return await axios({
      url: '/api/mts/order/page',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 辅营子订单详情查询
export async function queryAncillarySubDetail (params) {
  try {
    const data = await axios({
      url: '/api/mts/order/sub/detail',
      method: 'post',
      data: params
    })

    if (data) {
      const { status, extProductType, paxSegmentInfoDTO } = data

      data.statusCn = aclSubOrderStatusMap[status]
      data.extProductTypeCn = productTypeMap[extProductType]
      paxSegmentInfoDTO.certificateTypeCn = idTypeV2Map[paxSegmentInfoDTO.certificateType]
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 随票辅营订单取消
export async function cancelExtProduct (params) {
  try {
    return await axios({
      url: '/api/order/extProduct/cancel',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 辅营订单详情查询
export async function queryAncillaryDetail (params) {
  try {
    const data = await axios({
      url: '/api/mts/order/detail',
      method: 'post',
      data: params
    })

    if (data) {
      const { timeLimit, status, passengers } = data

      data.orderDuration = new Date(timeLimit).getTime() - new Date().getTime()
      data.statusCn = aclOrderStatusMap[status]
      passengers.forEach((pass) => {
        pass.certificateTypeCn = idTypeV2Map[pass.certificateType]
        pass.details.forEach((prod) => {
          prod.productTypeCn = productTypeMap[prod.productType]
          prod.orderStatusCn = aclOrderStatusMap[prod.orderStatus]
          prod.subOrderStatusCn = aclSubOrderStatusMap[prod.subOrderStatus]
        })
      })
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}
